import { Feed } from '../components/Feed'

import { RotaPrivada } from './RotaPrivada'

export function FeedPage() {
    return (
        <RotaPrivada>
            <Feed />
        </RotaPrivada>
    )
}